import { useEffect, useRef } from "react";

type InfiniteScrollProps<T extends HTMLElement> = {
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
  root?: HTMLElement | null;
  rootMargin?: string;
  render: (ref: React.RefObject<T>) => React.ReactNode;
};

export function InfiniteScroll<T extends HTMLElement>({
  hasMore,
  isLoading,
  onLoadMore,
  root = null,
  rootMargin = "200px",
  render,
}: InfiniteScrollProps<T>) {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    if (!hasMore || isLoading || !ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onLoadMore();
        }
      },
      { root, rootMargin }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [hasMore, isLoading, onLoadMore, root, rootMargin]);

  return <>{render(ref)}</>;
}
